import { useState, useEffect } from 'react';

export const useDataEntryState = ({
  editingDataPoint,
  selectedDate,
  studentDataPoints,
  allowNewEntry = false,
}) => {
  const [existingEntry, setExistingEntry] = useState(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [goalNo, setGoalNo] = useState(null);
  const [existingPromptingType, setExistingPromptingType] = useState(null);
  const [criteria, setCriteria] = useState([]);
  const [promptingType, setPromptingType] = useState('');
  const [goalPromptingLevel, setGoalPromptingLevel] = useState('');

  useEffect(() => {
    if (editingDataPoint) {
      setExistingEntry(editingDataPoint);
    } else if (!allowNewEntry) {
      // Only set existing entry if we're not allowing new entries
      const entry = studentDataPoints?.find((dp) => dp.date === selectedDate);
      setExistingEntry(entry);
    } else {
      // Allow new entry even if data exists for this date
      setExistingEntry(null);
    }
  }, [selectedDate, studentDataPoints, editingDataPoint, allowNewEntry]);

  return {
    existingEntry,
    isDeleteDialogOpen,
    isDisabled,
    isSaving,
    isDeleting,
    goalNo,
    existingPromptingType,
    criteria,
    promptingType,
    goalPromptingLevel,

    setExistingEntry,
    setIsDeleteDialogOpen,
    setIsDisabled,
    setIsSaving,
    setIsDeleting,
    setGoalNo,
    setExistingPromptingType,
    setCriteria,
    setPromptingType,
    setGoalPromptingLevel,
  };
};
